import { LitElement, html, ref, createRef, utils } from '@hh/global.js'
const { debounce } = utils
class HHHeaderPredictiveSearch extends LitElement {
  $form = createRef()

  constructor() {
    super()

    this.route = '/search/suggest'
    this.cachedResults = {}
    this.form = this.querySelector('form')
    this.input = this.querySelector('.header-search__input')
    this.clearButton = this.querySelector('.header-search__clear')
    this.suggestionButtons = this.querySelectorAll('.search-modal__suggested button')
    this.setupEventListeners()

  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this))
    this.input.addEventListener('focus', this.onFocus.bind(this))
    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event)
      }, 150).bind(this)
    )
    this.clearButton.addEventListener('click', (event) => {
      this.input.value = ''
      this.onChange(event)
    })

    this.suggestionButtons.forEach((button) => {
      button.addEventListener(
        'click',
        ((event) => {
          event.preventDefault()
          this.input.nextElementSibling.style.transform = "translateY(-9px)";
          if (button.dataset.term.length) {
            this.input.value = button.dataset.term
            this.updateTermButtonState(button)
            this.onChange(event)

          }
        }).bind(this)
      )
    })

  }

  getQuery() {
    return this.input.value.trim()
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) event.preventDefault()
  }

  onFocus() {
    const searchTerm = this.getQuery()
    if (!searchTerm.length) return
    if (this.getAttribute('header-results') === 'true') {
      this.open()
    } else {
      this.getResult(searchTerm)
    }

  }

  updateTermButtonState(button) {
    if (this.getQuery() === button.dataset.term) {
      button.setAttribute('disabled', true)
    }
  }

  onChange() {
    const searchTerm = this.getQuery()

    if (!searchTerm.length) {
      this.close(true)
      return
    }

    if (searchTerm.length < 3) {
      this.close()
      return
    }

    this.resetSuggestions()
    this.getResult(searchTerm)
  }

  resetSuggestions() {
    this.suggestionButtons.forEach((button) => {
      if (this.getQuery() !== button.dataset.term) {
        button.removeAttribute('disabled')
      }
    })
  }

  onClear() {
    this.input.value = ""
    this.onChange()
  }

  getResult(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase()
    this.setLiveRegionLoadingState()

    if (this.cachedResults[queryKey]) {
      this.renderResults(this.cachedResults[queryKey], false)
      return
    }

    fetch(
      `${this.route}?q=${encodeURIComponent(searchTerm)}&section_id=header&resources[limit]=6&resources[limit_scope]=each`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status)
          this.close()
          throw error
        }
        return response.text()
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#js-header-search-modal')
        this.cachedResults[queryKey] = resultsMarkup
        this.renderResults(resultsMarkup)
      })
      .catch((error) => {
        this.close()
        throw error
      })
  }

  renderResults(resultsMarkup, reset_focustrap = true) {
    this.querySelector('#header-searchresults-container').innerHTML = resultsMarkup.querySelector('#header-searchresults-container').innerHTML
    this.setAttribute('header-results', true)
    this.setLiveRegionResults()

    if (resultsMarkup.querySelector('.header-search__dropdown--no-results')) {
      this.closest('.header-search__dropdown').classList.add('header-search__dropdown--no-results')
    } else {
      this.closest('.header-search__dropdown').classList.remove('header-search__dropdown--no-results')
    }

    if (reset_focustrap) {
      const focusTrapElem = this.closest('hh-details-modal')?.shadowRoot?.querySelector('hh-focus-trap') || null
      if (focusTrapElem) {
        setTimeout(() => {
          focusTrapElem.setAttribute('active', false)
          focusTrapElem.setAttribute('active', true)
        }, 100)
      }
    }
  }

  setLiveRegionLoadingState() {
    this.setAttribute('loading', true)
  }

  setLiveRegionResults() {
    this.removeAttribute('loading')
  }

  open() {
    this.setAttribute('open', true);
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
    }
    this.removeAttribute('header-results');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.querySelector('#header-searchresults-container').innerHTML = ''
  }

  render() {
    return html`
          <slot name="heading"></slot>
          <slot name="form" @clearSearch="${this.onClear}"></slot>
          <slot name="suggestion"></slot>
          <slot name="header-results"></slot>
          `
  }

}

customElements.define('hh-header-predictive-search', HHHeaderPredictiveSearch)
